import {injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {TransformerInterface} from "./transformerInterface";
import {CommandDTO} from "../domain/dtos/command.dto";
import {ReleaseEntityLockCommand} from "../commands/release-entity-lock.command";
import {LockEntityPayload} from "../commands/lock-entity.command";

/**
 * Serialises a ReleaseEntityLockCommand into the backend command DTO.
 *
 * A dedicated transformer is REQUIRED, not a nicety. Without one the generic
 * command→DTO fallback runs, and that fallback demands a change-tracked proxy
 * as the payload — a lock command carries a plain object, so it throws
 * "The payload of the command must be a proxified object". The throw happens
 * OUTSIDE the CommandBus's try block, so it wedges the bus for the rest of the
 * session rather than failing the one command.
 *
 * Measured on com.open2done.local 2026-09-06: clicking "Bearbeiten" on a
 * Linkview produced exactly that, and no unit test saw it because they all stub
 * the bus.
 */
@injectable()
@transformer({
    source: ReleaseEntityLockCommand,
    target: `dto`
})
export class ReleaseEntityLockCommandToDtoTransformer implements TransformerInterface<CommandDTO<LockEntityPayload>, ReleaseEntityLockCommand> {

    public async transform(command: ReleaseEntityLockCommand): Promise<CommandDTO<LockEntityPayload>> {
        return <CommandDTO<LockEntityPayload>>{
            uid: command.uid,
            name: command.name,
            mainEntityClass: command.mainEntityClass,
            mainEntityUid: command.mainEntityUid,
            payload: command.payload,
        };
    }
}
